import React, { useState } from "react";
import Shell from "../../common/components/Shell/Shell";
import { Grid } from "@mui/material";
import SuggestionPresenter from "./SuggestionPresenter";
import { useTranslation } from "react-i18next";

export default function SuggestionController() {

  const { i18n, t } = useTranslation();
  return (
    <>
      <Shell>
        <Grid
          container
          style={{
            maxWidth: "auto",
            marginLeft: "7.25em",
          }}
        >
          {" "}
          <SuggestionPresenter
            trans={t}
            i18n={i18n}
          />
        </Grid>
      </Shell>
    </>
  );
}
